import { useMemo } from "react";
import {
    useEntitiesContexts,
    useEntitiesContextsQueryState,
} from "@hooks/useEntitiesContexts";
import { INVOICE_ACCOUNT_FILTER_SOURCE_TYPES } from "@common/constants/invoices";
import { InvoicesViewProvider } from "../../contexts/InvoicesViewProvider";
import { InvoicePageContent } from "./InvoicePageContent";

export const InvoicesPage: React.FC = () => {
    const entities = useEntitiesContexts();
    const entitiesQueryState = useEntitiesContextsQueryState();

    const invoicingAccounts = useMemo(() => {
        if (!entities) {
            return [];
        }

        return entities.flatMap((e) =>
            e.financialAccounts.filter((f) =>
                INVOICE_ACCOUNT_FILTER_SOURCE_TYPES.includes(f.sourceType),
            ),
        );
    }, [entities]);

    if (entitiesQueryState?.status === "pending") {
        return null;
    }

    return (
        <InvoicesViewProvider>
            <InvoicePageContent invoicingAccounts={invoicingAccounts} />
        </InvoicesViewProvider>
    );
};
